import { render, staticRenderFns } from "./UniConnections.vue?vue&type=template&id=3e905c74&scoped=true&"
import script from "./UniConnections.vue?vue&type=script&lang=js&"
export * from "./UniConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e905c74",
  null
  
)

export default component.exports